import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearingHousePropertiesType, clearingHouseType } from '../../types';
import { onActionKey } from '../../utils';
import useDetailHandler from '../../hooks/useDetailHandler';
import ClearingHouseDetailTab from './ClearingHouseDetailTab';
import './_styles_/ClearingHouseRow.css';

ClearingHouseRow.propTypes = {
    clearingHouse: clearingHouseType.isRequired,
    clearingHouseProps: clearingHousePropertiesType.isRequired,
};

function ClearingHouseRow(props) {
    const {
        clearingHouse,
        clearingHouseProps,
    } = props;
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(clearingHouse.code);
    return (
        <>
            <div className="rich-list-row clearing-house-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="clearing-house-header--values--name">{clearingHouse.name}</div>
                <div className="clearing-house-header--values--code">{clearingHouse.code}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <ClearingHouseDetailTab
                    clearingHouse={clearingHouse}
                    onDetailDelete={onDetailDelete}
                    clearingHouseProps={clearingHouseProps}
                />
            )}
        </>
    );
}

export default ClearingHouseRow;
